import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import authSlice from "../slice/authSlice";
import commonSlice from "../slice/commonSlice";
import colorSlice from "../slice/colorSlice";
import sizeSlice from "../slice/sizeSlice";
import sizeChartSlice from "../slice/sizeChartSlice";
import roleSlice from "../slice/roleSlice";
import userSlice from "../slice/userSlice";
import vendorSlice from "../slice/vendorSlice";
import variantSlice from "../slice/variantSlice";
import productSlice from "../slice/productSlice";
import logsSlice from "../slice/logsSlice";
import dashboardSlice from "../slice/dashboardSlice";
import fabricSlice from "../slice/fabricSlice";
import inventorySlice from "../slice/inventorySlice";
import categorySlice from "../slice/categorySlice";
import poSlice from "../slice/poSlice";
import billSlice from "../slice/billSlice";
import platformSlice from "../slice/platformSlice";
import expenseTypeSlice from "../slice/expenseTypeSlice";
import salesInvoiceSlice from "../slice/salesInvoiceSlice";
import entrybookSlice from "../slice/entrybookSlice";
import incomeTypeSlice from "../slice/incomeTypeSlice";
import sampleSlice from "../slice/sampleSlice";
import sampleReturnSlice from "../slice/sampleReturnSlice";
import auditSlice from "../slice/auditSlice";
import auditHistorySlice from "../slice/auditHistorySlice";
import meeshoSlice from "../slice/meeshoSlice";
import debitNoteSlice from "../slice/debitNoteSlice";
import meeshoOrderManagementSlice from "../slice/meeshoOrderManagementSlice";
import attendanceSlice from "../slice/attendanceSlice";
import myntraSlice from "../slice/myntraSlice";
import flipkartSlice from "../slice/flipkartSlice";
import appSalesReportSlice from "../slice/appSalesReportSlice";
import meeshoReturnReasonSlice from "../slice/meeshoReturnReasonSlice";
import orderLabelSlice from "../slice/orderLabelSlice";

const rootReducer = combineReducers({
  auth: authSlice,
  common: commonSlice,
  color: colorSlice,
  size: sizeSlice,
  sizeChart: sizeChartSlice,
  fabric: fabricSlice,
  inventory: inventorySlice,
  platform: platformSlice,
  expenseType: expenseTypeSlice,
  incomeType: incomeTypeSlice,
  category: categorySlice,
  role: roleSlice,
  user: userSlice,
  vendor: vendorSlice,
  product: productSlice,
  variant: variantSlice,
  logs: logsSlice,
  dashboard: dashboardSlice,
  po: poSlice,
  bill: billSlice,
  salesInvoice: salesInvoiceSlice,
  entryBook: entrybookSlice,
  sample: sampleSlice,
  sampleReturn: sampleReturnSlice,
  audit: auditSlice,
  auditHistory: auditHistorySlice,
  meesho: meeshoSlice,
  debitNote: debitNoteSlice,
  meeshoOrderManagement: meeshoOrderManagementSlice,
  attendance: attendanceSlice,
  myntra: myntraSlice,
  flipkart: flipkartSlice,
  appSalesReport: appSalesReportSlice,
  meeshoReturnReason: meeshoReturnReasonSlice,
  orderLabel: orderLabelSlice,
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.REACT_APP_NODE_ENV !== "production",
});

export const persister = persistStore(store);
